<template>
  <div class="pointer">
    <div
      @mouseover="isHovering = true"
      @mouseout="isHovering = false"
      :class="{ hovering: isHovering }"
    >
      <img
        style="border-radius: 130px"
        class=""
        :src="addToUrl(speaker.speakerImageURL, cloudinaryParams)"
        alt=""
      />
      <div class="glitch__layers">
        <div
          :class="[
            isHovering ? 'glitch__layer' : '',
            row2 ? 'glitch-position' : '',
          ]"
          :style="{
            'background-image':
              'url(' +
              addToUrl(speaker.speakerImageURL, cloudinaryParams2) +
              ')',
          }"
        ></div>
      </div>
      <div class="glitch__layers">
        <div
          :class="[
            isHovering ? 'glitch__layer' : '',
            row2 ? 'glitch-position' : '',
          ]"
          :style="{
            'background-image':
              'url(' +
              addToUrl(speaker.speakerImageURL, cloudinaryParams2) +
              ')',
          }"
        ></div>
      </div>
      <div class="glitch__layers">
        <div
          :class="[
            isHovering ? 'glitch__layer' : '',
            row2 ? 'glitch-position' : '',
          ]"
          :style="{
            'background-image':
              'url(' +
              addToUrl(speaker.speakerImageURL, cloudinaryParams2) +
              ')',
          }"
        ></div>
      </div>
      <div class="glitch__layers">
        <div
          :class="[
            isHovering ? 'glitch__layer' : '',
            row2 ? 'glitch-position' : '',
          ]"
          :style="{
            'background-image':
              'url(' +
              addToUrl(speaker.speakerImageURL, cloudinaryParams2) +
              ')',
          }"
        ></div>
      </div>
    </div>

    <div class="speaker-info">
      <strong class="text-center"
        >{{ speaker.speakerFirstName }} {{ speaker.speakerLastName }}
        <span
          v-if="activeSpeaker == speaker._id"
          class="material-symbols-outlined"
        >
          collapse_all
        </span>
        <span v-else class="material-symbols-outlined"> expand_all </span>
      </strong>
      <p class="text-center">{{ speaker.workshopName }}</p>
    </div>
  </div>
</template>

<script>
//

export default {
  props: ["speaker", "row2", "activeSpeaker"],
  data() {
    return {
      cloudinaryParams:
        "e_grayscale/co_rgb:7246C1/w_1100/w_500,h_500,c_crop,g_face,c_thumb,b_rgb:DDDDDD/w_170",
      cloudinaryParams2:
        "e_grayscale/co_rgb:7246C1/w_1100/w_250,h_250,c_crop,g_face,c_thumb,b_rgb:DDDDDD/w_170",
      isHovering: false,
    };
  },
  methods: {
    addToUrl(url, stringToAdd) {
      if (!url) {
        return;
      }
      const array = url.split("upload/");
      array.splice(1, 0, "upload/" + stringToAdd + "/");
      const urlString = array.join("");

      return urlString;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

@media (max-width: 500px) {
  .speaker-info strong {
    font-size: 0.8rem;
  }
}

.material-symbols-outlined {
  font-size: 17px;
}
.glitch__layers {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.glitch__layer {
  position: absolute;
  left: 30px;
  right: 0;
  top: 0;
  bottom: 0;
  background-repeat: no-repeat;
  background-position: 0 0;
  @media (max-width: 500px) {
    display: none;
  }
  @media (min-width: 1500px) {
    left: 100px;
  }
  @media (min-width: 2000px) {
    left: 150px;
  }
  @media (min-width: 2500px) {
    left: 200px;
  }
}

.glitch-position {
  left: 60px;
  @media (min-width: 1500px) {
    left: 160px;
  }
  @media (min-width: 2000px) {
    left: 200px;
  }
  @media (min-width: 2500px) {
    left: 260px;
  }
}

.glitch__layer:nth-child(1) {
  transform: translateX(-0%);
  animation: glitch-anim-1 2s infinite linear alternate;
}
.glitch__layer:nth-child(2) {
  transform: translateX(0%) translateY(3%);
  animation: glitch-anim-2 2.3s -0.8s infinite linear alternate;
}
.glitch__layer:nth-child(3) {
  transform: translateX(0%);
  animation: glitch-anim-flash 1s infinite linear;
}
.glitch__layer:nth-child(4) {
  transform: translateX(0%);
  animation: glitch-anim-flash 1s infinite linear;
}
@keyframes glitch-anim-1 {
  0% {
    clip-path: polygon(0 0%, 100% 0%, 100% 5%, 0 5%);
  }
  10% {
    clip-path: polygon(0 15%, 100% 15%, 100% 15%, 0 15%);
  }
  20% {
    clip-path: polygon(0 10%, 100% 10%, 100% 20%, 0 20%);
  }
  30% {
    clip-path: polygon(0 1%, 100% 1%, 100% 2%, 0 2%);
  }
  40% {
    clip-path: polygon(0 35%, 100% 35%, 100% 35%, 0 35%);
  }
  50% {
    clip-path: polygon(0 45%, 100% 45%, 100% 46%, 0 46%);
  }
  60% {
    clip-path: polygon(0 50%, 100% 50%, 100% 70%, 0 70%);
  }
  70% {
    clip-path: polygon(0 70%, 100% 70%, 100% 70%, 0 70%);
  }
  80% {
    clip-path: polygon(0 80%, 100% 80%, 100% 80%, 0 80%);
  }
  90% {
    clip-path: polygon(0 50%, 100% 50%, 100% 55%, 0 55%);
  }
  100% {
    clip-path: polygon(0 60%, 100% 60%, 100% 70%, 0 70%);
  }
}
@keyframes glitch-anim-2 {
  0% {
    clip-path: polygon(0 15%, 100% 15%, 100% 30%, 0 30%);
  }
  15% {
    clip-path: polygon(0 3%, 100% 3%, 100% 3%, 0 3%);
  }
  25% {
    clip-path: polygon(0 8%, 100% 8%, 100% 20%, 0 20%);
  }
  30% {
    clip-path: polygon(0 20%, 100% 20%, 100% 20%, 0 20%);
  }
  45% {
    clip-path: polygon(0 45%, 100% 45%, 100% 45%, 0 45%);
  }
  50% {
    clip-path: polygon(0 50%, 100% 50%, 100% 57%, 0 57%);
  }
  65% {
    clip-path: polygon(0 60%, 100% 60%, 100% 60%, 0 60%);
  }
  75% {
    clip-path: polygon(0 80%, 100% 80%, 100% 80%, 0 80%);
  }
  80% {
    clip-path: polygon(0 40%, 100% 40%, 100% 60%, 0 60%);
  }
  95% {
    clip-path: polygon(0 45%, 100% 45%, 100% 60%, 0 60%);
  }
  100% {
    clip-path: polygon(0 11%, 100% 11%, 100% 15%, 0 15%);
  }
}
@keyframes glitch-anim-flash {
  0% {
    opacity: 0.2;
  }
  30%,
  100% {
    opacity: 0;
  }
}

.pointer {
  cursor: pointer !important;
}
</style>


// WEBPACK FOOTER //
// src/components/WorkshopSpeaker.vue